function e(e){return()=>e}export{e as constant};
//# sourceMappingURL=constant-ZKESIgIV.js.map